import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.regexp.replace";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import bus from "../common/bus";
import { SortField } from "../../utils/helper";
export default {
  data: function data() {
    return {
      collapse: false,
      items: [],
      menuBarBackgroundColor: '#324157',
      menuTextColor: '#bfcbd9'
    };
  },
  computed: {
    onRoutes: function onRoutes() {
      return this.$route.path.replace('/', '');
    }
  },
  created: function created() {
    var _this = this;

    this.getSystemInfo();
    this.getData(); // 通过 Event Bus 进行组件间通信，来折叠侧边栏

    bus.$on('collapse', function (msg) {
      _this.collapse = msg;
      bus.$emit('collapse-content', msg);
    });
  },
  mounted: function mounted() {},
  methods: {
    getData: function getData() {
      var _this2 = this;

      var username = localStorage.getItem('ms_username');
      var userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));

      if (username != undefined && username != null) {
        this.$zybhttp.post('Menu/GetMenuLeft', {
          Field1: userInfo.userType
        }).then(function (res) {
          if (res.data.status == 0) {
            res = res.data;
            var d = res.data.list;

            var list = _this2.MenuCarding(d);

            _this2.items = list;
          } else {
            _this2.$notify.error(res.message);
          }
        }).catch(function (err) {
          return _this2.$notify.error('网络异常！获取菜单失败！');
        });
      }
    },
    MenuCarding: function MenuCarding(data) {
      var menus = [];
      var d = JSON.parse(JSON.stringify(data));
      var dOne = d.filter(function (x) {
        return x.parentId == 0;
      }); // var dOne = d.filter(function (e) {
      //     return e.parentId == 9999;
      // });

      var dOneSort = dOne.sort(SortField('sort', 'asc')).map(function (x) {
        return {
          id: x.id,
          code: x.code,
          icon: x.icon,
          title: x.title
        };
      });
      menus = menus.concat(dOneSort);
      menus.forEach(function (x) {
        var pid = x.id;
        var dtwo = d.filter(function (x) {
          return x.parentId == pid;
        });

        if (dtwo.length > 0) {
          var dtwoSort = dtwo.sort(SortField('sort', 'asc')).map(function (x) {
            return {
              id: x.id,
              code: x.code,
              icon: x.icon,
              title: x.title
            };
          });
          x.subs = dtwoSort;
        }
      });
      return menus;
    },
    getSystemInfo: function getSystemInfo() {
      var _this3 = this;

      this.$zybhttp.get('Business/GetSystemInfo', {}).then(function (res) {
        if (res.data.status == 0) {
          var d = res.data;
          _this3.version = d.msg;
          _this3.menuBarBackgroundColor = d.data.list[0].menuBarBackgroundColor;
          _this3.menuTextColor = d.data.list[0].textColor;
        } else {
          _this3.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this3.$notify.error('网络异常！获取列表失败！');
      });
    }
  }
};